import React, { useRef } from "react";
import style from "./dialog.module.css";

const Button = ({
  text,
  icon,
  appearance = 0,
  fullWidth,
  rounded,
  hoverEffect,
  spaceTop = 0,
  spaceLeft = 0,
  action
}) => {
  const buttonRef = useRef(null);

  const createRipple = (event) => {
    const button = buttonRef.current;
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.getBoundingClientRect().left - radius
      }px`;
    circle.style.top = `${event.clientY - button.getBoundingClientRect().top - radius
      }px`;
    circle.classList.add(style.ripple);

    // remove old ripple if exists
    const ripple = button.getElementsByClassName(style.ripple)[0];
    if (ripple) ripple.remove();

    button.appendChild(circle);

    if (action && action.onClick) action.onClick(event);
  };

  return (
    <button
      ref={buttonRef}
      className={`${style.button} 
        ${appearance == 0 ? style.positive
          : appearance == 1 ? style.negative
            : appearance == 2 ? style.neutral
            : appearance == 3 ? style.outlined
              : style.disabled}
        ${hoverEffect ? style.hoverEffect : ""} 
        ${rounded ? style.rounded : ""} 
        ${fullWidth ? style.fullWidth : ""}`}
      style={{ marginLeft: spaceLeft, marginTop: spaceTop }}
      onClick={createRipple}
    >
      {text}
      {icon && (
        <span className="material-symbols-outlined mg-l-5">
          {icon}
        </span>
      )}

    </button>
  );
};

export default Button;